import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { allTutors } from '../data/tutorsData';

const { FiX, FiMapPin, FiPhone, FiMessageCircle, FiCheckCircle, FiStar } = FiIcons;

const Stars = () => (
  <div className="flex items-center gap-0.5">
    {[...Array(5)].map((_, i) => (
      <FiStar key={i} className="w-3 h-3 fill-current text-yellow-400" />
    ))}
  </div>
);

const TutorCard = ({ tutor }) => (
  <div className="bg-gray-50 rounded-2xl p-5 border border-gray-100 hover:border-red-100 hover:shadow-md transition-all duration-200">
    <div className="flex gap-4 mb-4">
      <div className="relative flex-shrink-0">
        <img src={tutor.img} alt={tutor.name} className="w-16 h-16 rounded-2xl object-cover border-2 border-white shadow" />
        {tutor.verified && (
          <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center border-2 border-white">
            <FiCheckCircle className="text-white w-3 h-3 fill-current" />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-1">
          <h4 className="font-extrabold text-slate-900 text-sm tracking-tight truncate">{tutor.name}</h4>
          <span className="text-xs bg-blue-50 text-blue-600 font-bold px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">{tutor.exp}</span>
        </div>
        <p className="text-xs text-gray-500 font-semibold mb-1.5 leading-tight">{tutor.qualifications}</p>
        <Stars />
      </div>
    </div>
    <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-xl mb-4 border border-gray-100">
      <FiMapPin className="text-primary w-3.5 h-3.5 flex-shrink-0" />
      <span className="text-xs font-semibold text-slate-600 truncate">{tutor.locations.join(', ')}</span>
    </div>
    <div className="flex gap-2">
      <a
        href="tel:+919415905584"
        className="flex-1 flex items-center justify-center gap-1.5 bg-primary text-white py-2.5 rounded-xl text-xs font-extrabold hover:bg-primary-hover transition shadow-sm tracking-wide"
      >
        <FiPhone className="w-3.5 h-3.5" />
        Talk to Tutor
      </a>
      <a
        href="https://wa.me/919415905584"
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-1.5 bg-green-500 text-white py-2.5 rounded-xl text-xs font-extrabold hover:bg-green-600 transition shadow-sm tracking-wide"
      >
        <FiMessageCircle className="w-3.5 h-3.5" />
        WhatsApp
      </a>
    </div>
  </div>
);

const SubjectTutorsModal = ({ subject, onClose }) => {
  const tutors = allTutors.filter(t => t.subjects.includes(subject));

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div
        className="relative bg-white rounded-3xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col"
        onClick={e => e.stopPropagation()}
      >
        <div className="h-1.5 bg-gradient-to-r from-primary via-orange-400 to-yellow-400 rounded-t-3xl flex-shrink-0" />
        <div className="flex items-center justify-between px-7 py-5 border-b border-gray-100 flex-shrink-0">
          <div>
            <h2 className="text-xl font-extrabold text-slate-900 tracking-tight">{subject} Tutors</h2>
            <p className="text-xs text-gray-500 font-medium mt-0.5">{tutors.length} verified tutors available</p>
          </div>
          <button onClick={onClose} className="w-9 h-9 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition">
            <FiX className="w-4 h-4 text-gray-600" />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-6">
          {tutors.length === 0 ? (
            <div className="text-center py-12 text-gray-400 font-semibold">No tutors found for this subject.</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {tutors.map((tutor, idx) => <TutorCard key={idx} tutor={tutor} />)}
            </div>
          )}
        </div>
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex-shrink-0 rounded-b-3xl">
          <p className="text-xs text-center text-gray-500 font-medium">
            Need help choosing?{' '}
            <a href="tel:+919415905584" className="text-primary font-bold hover:underline">Call us at +91 9415905584</a>{' '}
            and we'll match you with the best tutor.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubjectTutorsModal;